import { render, staticRenderFns } from "./WorkAreaAddNew.vue?vue&type=template&id=43ab99e3"
import script from "./WorkAreaAddNew.vue?vue&type=script&lang=js"
export * from "./WorkAreaAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports